import { IntegrationsService } from '../../../../../../../providers/IntegrationsProvider/Integrations.service.ts';
import { useWorkspaceContext } from '../../../../../../../providers/WorkspaceProvider/Workspace.context.ts';
import { useMetaConnectionModalContext } from '../../MetaConnectionModal.hook.ts';

export default function useMetaStepAllPages() {
  const { currentWorkspaceId } = useWorkspaceContext();
  const { setMetaPages } = useMetaConnectionModalContext();

  const getAllPages = async () => {
    if (!currentWorkspaceId) return;
    await IntegrationsService.getFacebookPages({
      workspaceId: currentWorkspaceId,
    }).then((response) => {
      // null means the workspace has no Meta account connected, so there are no pages to
      // choose from. That is a normal state on this step, not a failure — the service
      // answers 200 with an empty id and the pages call is skipped instead of being sent
      // without one.
      setMetaPages(response?.data ?? []);
    });
  };

  return {
    getAllPages,
  };
}
